import React from 'react';
import { Heading, Text, Box, HStack, Button } from '@medely/ui-kit';
import { FixedFooterLayout } from '@mp/components';

type PreQuestionsPageProps = {
  prevStep: () => void;
  handleSubmit: () => void;
};

export const PreQuestionsPage = ({ prevStep, handleSubmit }: PreQuestionsPageProps) => {
  return (
    <FixedFooterLayout
      footerContent={
        <HStack width="100%" gap={2}>
          <Button variant="outlined" onClick={prevStep} fullWidth>
            Back
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit} fullWidth>
            Continue
          </Button>
        </HStack>
      }
    >
      <Heading size="s">Screening Questions</Heading>
      <Box pt={2}>
        <Text size="m">
          Please take a moment to answer a few clinical questions to assess your knowledge and
          experience in your selected field. Please answer each question thoroughly and in your own
          words.
        </Text>
      </Box>
    </FixedFooterLayout>
  );
};
